export const serializeMailBox = mailBox => ({
  label: mailBox.label,
  value: mailBox.value,
});

export const serializeMailBoxes = rawData => {
  if (!rawData.mail_boxes || rawData.mail_boxes.length <= 0) {
    return {
      mailBoxes: [],
      meta: null,
    };
  }

  return {
    mailBoxes: rawData.mail_boxes.map(mailBox => serializeMailBox(mailBox)),
    meta: rawData.meta,
  };
};
